import {
  LayoutDashboard, Map, Sprout, ListChecks, CalendarRange, Users, Boxes, Wallet,
  Wrench, CloudSun, LineChart, Satellite, BarChart3, Bot, FileText, Contact,
  Landmark, UserCog, Download, Stethoscope, QrCode, BookOpen, ShieldCheck, MessageSquareWarning, Sparkles,
} from "lucide-react";

export const NAV_GROUPS = [
  { label: "overview", items: [
    { key: "dashboard", to: "/", icon: LayoutDashboard },
    { key: "madat", to: "/saathi", icon: Sparkles },
    { key: "fasalDoctor", to: "/fasal-doctor", icon: Stethoscope },
  ] },
  {
    label: "landCrops", items: [
      { key: "land", to: "/farms", icon: Map },
      { key: "crops", to: "/crops", icon: Sprout },
      { key: "operations", to: "/operations", icon: ListChecks },
      { key: "planning", to: "/planning", icon: CalendarRange },
    ],
  },
  {
    label: "resFinance", items: [
      { key: "resources", to: "/resources", icon: Users },
      { key: "inventory", to: "/inventory", icon: Boxes },
      { key: "accounting", to: "/accounting", icon: Wallet },
      { key: "equipment", to: "/equipment", icon: Wrench },
    ],
  },
  {
    label: "intelligence", items: [
      { key: "weather", to: "/weather", icon: CloudSun },
      { key: "market", to: "/market", icon: LineChart },
      { key: "satellite", to: "/satellite", icon: Satellite },
      { key: "analytics", to: "/analytics", icon: BarChart3 },
      { key: "ai", to: "/ai", icon: Bot },
    ],
  },
  {
    label: "admin", items: [
      { key: "documents", to: "/documents", icon: FileText },
      { key: "crm", to: "/crm", icon: Contact },
      { key: "schemes", to: "/schemes", icon: Landmark },
      { key: "herbTrace", to: "/herb-trace", icon: QrCode },
      { key: "team", to: "/team", icon: UserCog },
      { key: "export", to: "/export", icon: Download },
    ],
  },
];
